import { React, useState, useEffect } from 'react';
import styled from 'styled-components';
import Lottie from 'lottie-react';
import moment from 'moment';

import NewDataBar from './NewDataBar';

import LoadingAnimation from '../../../Animation/LoadingAnimation.json';

export default function RevenueBox(props) {
  const {
    today,
    startDate,
    endDate,
    calcDateText,

    totalMaxPrice,
    revenue,
    prevRevenue,
    memberships,

    isRevenueLoading,
    setIsRevenueLoading,

    isOpenPartnerGymSales,
    isMonthAttendanceLoading
  } = props;


  const monthlyDate = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];

  const [thisMonthTotalPrice, setThisMonthTotalPrice] = useState(0);
  const [thisYearMaxPrice, setThisYearMaxPrice] = useState(0);
  const [thisYear, setThisYear] = useState([]);
  const [maximum, setMaximum] = useState(0);
  const [membershipSaleRateInfos, setMembershipSaleRateInfos] = useState([]);


  useEffect(() => {
    let one = { totalPrice: 0, cashPrice: 0, cardPrice: 0, discountPrice: 0, notReceived: 0, prevTotalPrice: 0, sales: [], selectedPaymentOptions: [] };
    let two = { totalPrice: 0, cashPrice: 0, cardPrice: 0, discountPrice: 0, notReceived: 0, prevTotalPrice: 0, sales: [], selectedPaymentOptions: [] };
    let three = { totalPrice: 0, cashPrice: 0, cardPrice: 0, discountPrice: 0, notReceived: 0, prevTotalPrice: 0, sales: [], selectedPaymentOptions: [] };
    let four = { totalPrice: 0, cashPrice: 0, cardPrice: 0, discountPrice: 0, notReceived: 0, prevTotalPrice: 0, sales: [], selectedPaymentOptions: [] };
    let five = { totalPrice: 0, cashPrice: 0, cardPrice: 0, discountPrice: 0, notReceived: 0, prevTotalPrice: 0, sales: [], selectedPaymentOptions: [] };
    let six = { totalPrice: 0, cashPrice: 0, cardPrice: 0, discountPrice: 0, notReceived: 0, prevTotalPrice: 0, sales: [], selectedPaymentOptions: [] };
    let seven = { totalPrice: 0, cashPrice: 0, cardPrice: 0, discountPrice: 0, notReceived: 0, prevTotalPrice: 0, sales: [], selectedPaymentOptions: [] };
    let eight = { totalPrice: 0, cashPrice: 0, cardPrice: 0, discountPrice: 0, notReceived: 0, prevTotalPrice: 0, sales: [], selectedPaymentOptions: [] };
    let nine = { totalPrice: 0, cashPrice: 0, cardPrice: 0, discountPrice: 0, notReceived: 0, prevTotalPrice: 0, sales: [], selectedPaymentOptions: [] };
    let ten = { totalPrice: 0, cashPrice: 0, cardPrice: 0, discountPrice: 0, notReceived: 0, prevTotalPrice: 0, sales: [], selectedPaymentOptions: [] };
    let eleven = { totalPrice: 0, cashPrice: 0, cardPrice: 0, discountPrice: 0, notReceived: 0, prevTotalPrice: 0, sales: [], selectedPaymentOptions: [] };
    let twelve = { totalPrice: 0, cashPrice: 0, cardPrice: 0, discountPrice: 0, notReceived: 0, prevTotalPrice: 0, sales: [], selectedPaymentOptions: [] };

    let prevOne = 0;
    let prevTwo = 0;
    let prevThree = 0;
    let prevFour = 0;
    let prevFive = 0;
    let prevSix = 0;
    let prevSeven = 0;
    let prevEight = 0;
    let prevNine = 0;
    let prevTen = 0;
    let prevEleven = 0;
    let prevTwelve = 0;

    let maxPrice = 0;

    for (let i = 0; i < revenue.length; i++) {
      if (revenue[i].approvalDate.split('T')[0].split('-')[1] === '01') {
        one.totalPrice += revenue[i].totalPrice;
        one.cashPrice += revenue[i].cashPrice;
        one.cardPrice += revenue[i].cardPrice;
        one.notReceived += revenue[i].notReceivedPrice;

        let selectedPaymentOptions = one.selectedPaymentOptions.slice();

        for (let j = 0; j < revenue[i].selectedPaymentOptions.length; j++) {
          let isExist = false;

          for (let h = 0; h < selectedPaymentOptions.length; h++) {
            if (revenue[i].selectedPaymentOptions[j].paymentOptionId === selectedPaymentOptions[h].paymentOptionId) {
              selectedPaymentOptions[h].price += revenue[i].selectedPaymentOptions[j].price;
              isExist = true;
              break;
            }
          }

          if (!isExist && revenue[i].selectedPaymentOptions[j].paymentOptionId !== 0) {
            selectedPaymentOptions.push({
              paymentOptionId: revenue[i].selectedPaymentOptions[j].paymentOptionId,
              paymentOptionName: revenue[i].selectedPaymentOptions[j].paymentOptionName,
              price: revenue[i].selectedPaymentOptions[j].price,
            });
          }
        }

        selectedPaymentOptions.sort((a, b) => a.paymentOptionId - b.paymentOptionId);

        one.selectedPaymentOptions = selectedPaymentOptions;
        one.sales.push(revenue[i]);

        if (one.totalPrice > maxPrice) maxPrice = one.totalPrice;
      }
      else if (revenue[i].approvalDate.split('T')[0].split('-')[1] === '02') {
        two.totalPrice += revenue[i].totalPrice;
        two.cashPrice += revenue[i].cashPrice;
        two.cardPrice += revenue[i].cardPrice;
        two.notReceived += revenue[i].notReceivedPrice;

        let selectedPaymentOptions = two.selectedPaymentOptions.slice();

        for (let j = 0; j < revenue[i].selectedPaymentOptions.length; j++) {
          let isExist = false;

          for (let h = 0; h < selectedPaymentOptions.length; h++) {
            if (revenue[i].selectedPaymentOptions[j].paymentOptionId === selectedPaymentOptions[h].paymentOptionId) {
              selectedPaymentOptions[h].price += revenue[i].selectedPaymentOptions[j].price;
              isExist = true;
              break;
            }
          }

          if (!isExist && revenue[i].selectedPaymentOptions[j].paymentOptionId !== 0) {
            selectedPaymentOptions.push({
              paymentOptionId: revenue[i].selectedPaymentOptions[j].paymentOptionId,
              paymentOptionName: revenue[i].selectedPaymentOptions[j].paymentOptionName,
              price: revenue[i].selectedPaymentOptions[j].price,
            });
          }
        }

        selectedPaymentOptions.sort((a, b) => a.paymentOptionId - b.paymentOptionId);

        two.selectedPaymentOptions = selectedPaymentOptions;
        two.sales.push(revenue[i]);

        if (two.totalPrice > maxPrice) maxPrice = two.totalPrice;
      }
      else if (revenue[i].approvalDate.split('T')[0].split('-')[1] === '03') {
        three.totalPrice += revenue[i].totalPrice;
        three.cashPrice += revenue[i].cashPrice;
        three.cardPrice += revenue[i].cardPrice;
        three.notReceived += revenue[i].notReceivedPrice;

        let selectedPaymentOptions = three.selectedPaymentOptions.slice();

        for (let j = 0; j < revenue[i].selectedPaymentOptions.length; j++) {
          let isExist = false;

          for (let h = 0; h < selectedPaymentOptions.length; h++) {
            if (revenue[i].selectedPaymentOptions[j].paymentOptionId === selectedPaymentOptions[h].paymentOptionId) {
              selectedPaymentOptions[h].price += revenue[i].selectedPaymentOptions[j].price;
              isExist = true;
              break;
            }
          }

          if (!isExist && revenue[i].selectedPaymentOptions[j].paymentOptionId !== 0) {
            selectedPaymentOptions.push({
              paymentOptionId: revenue[i].selectedPaymentOptions[j].paymentOptionId,
              paymentOptionName: revenue[i].selectedPaymentOptions[j].paymentOptionName,
              price: revenue[i].selectedPaymentOptions[j].price,
            });
          }
        }

        selectedPaymentOptions.sort((a, b) => a.paymentOptionId - b.paymentOptionId);

        three.selectedPaymentOptions = selectedPaymentOptions;
        three.sales.push(revenue[i]);

        if (three.totalPrice > maxPrice) maxPrice = three.totalPrice;
      }
      else if (revenue[i].approvalDate.split('T')[0].split('-')[1] === '04') {
        four.totalPrice += revenue[i].totalPrice;
        four.cashPrice += revenue[i].cashPrice;
        four.cardPrice += revenue[i].cardPrice;
        four.notReceived += revenue[i].notReceivedPrice;

        let selectedPaymentOptions = four.selectedPaymentOptions.slice();

        for (let j = 0; j < revenue[i].selectedPaymentOptions.length; j++) {
          let isExist = false;

          for (let h = 0; h < selectedPaymentOptions.length; h++) {
            if (revenue[i].selectedPaymentOptions[j].paymentOptionId === selectedPaymentOptions[h].paymentOptionId) {
              selectedPaymentOptions[h].price += revenue[i].selectedPaymentOptions[j].price;
              isExist = true;
              break;
            }
          }

          if (!isExist && revenue[i].selectedPaymentOptions[j].paymentOptionId !== 0) {
            selectedPaymentOptions.push({
              paymentOptionId: revenue[i].selectedPaymentOptions[j].paymentOptionId,
              paymentOptionName: revenue[i].selectedPaymentOptions[j].paymentOptionName,
              price: revenue[i].selectedPaymentOptions[j].price,
            });
          }
        }

        selectedPaymentOptions.sort((a, b) => a.paymentOptionId - b.paymentOptionId);

        four.selectedPaymentOptions = selectedPaymentOptions;
        four.sales.push(revenue[i]);

        if (four.totalPrice > maxPrice) maxPrice = four.totalPrice;
      }
      else if (revenue[i].approvalDate.split('T')[0].split('-')[1] === '05') {
        five.totalPrice += revenue[i].totalPrice;
        five.cashPrice += revenue[i].cashPrice;
        five.cardPrice += revenue[i].cardPrice;
        five.notReceived += revenue[i].notReceivedPrice;

        let selectedPaymentOptions = five.selectedPaymentOptions.slice();

        for (let j = 0; j < revenue[i].selectedPaymentOptions.length; j++) {
          let isExist = false;

          for (let h = 0; h < selectedPaymentOptions.length; h++) {
            if (revenue[i].selectedPaymentOptions[j].paymentOptionId === selectedPaymentOptions[h].paymentOptionId) {
              selectedPaymentOptions[h].price += revenue[i].selectedPaymentOptions[j].price;
              isExist = true;
              break;
            }
          }

          if (!isExist && revenue[i].selectedPaymentOptions[j].paymentOptionId !== 0) {
            selectedPaymentOptions.push({
              paymentOptionId: revenue[i].selectedPaymentOptions[j].paymentOptionId,
              paymentOptionName: revenue[i].selectedPaymentOptions[j].paymentOptionName,
              price: revenue[i].selectedPaymentOptions[j].price,
            });
          }
        }

        selectedPaymentOptions.sort((a, b) => a.paymentOptionId - b.paymentOptionId);

        five.selectedPaymentOptions = selectedPaymentOptions;
        five.sales.push(revenue[i]);

        if (five.totalPrice > maxPrice) maxPrice = five.totalPrice;
      }
      else if (revenue[i].approvalDate.split('T')[0].split('-')[1] === '06') {
        six.totalPrice += revenue[i].totalPrice;
        six.cashPrice += revenue[i].cashPrice;
        six.cardPrice += revenue[i].cardPrice;
        six.notReceived += revenue[i].notReceivedPrice;

        let selectedPaymentOptions = six.selectedPaymentOptions.slice();

        for (let j = 0; j < revenue[i].selectedPaymentOptions.length; j++) {
          let isExist = false;

          for (let h = 0; h < selectedPaymentOptions.length; h++) {
            if (revenue[i].selectedPaymentOptions[j].paymentOptionId === selectedPaymentOptions[h].paymentOptionId) {
              selectedPaymentOptions[h].price += revenue[i].selectedPaymentOptions[j].price;
              isExist = true;
              break;
            }
          }

          if (!isExist && revenue[i].selectedPaymentOptions[j].paymentOptionId !== 0) {
            selectedPaymentOptions.push({
              paymentOptionId: revenue[i].selectedPaymentOptions[j].paymentOptionId,
              paymentOptionName: revenue[i].selectedPaymentOptions[j].paymentOptionName,
              price: revenue[i].selectedPaymentOptions[j].price,
            });
          }
        }

        selectedPaymentOptions.sort((a, b) => a.paymentOptionId - b.paymentOptionId);

        six.selectedPaymentOptions = selectedPaymentOptions;
        six.sales.push(revenue[i]);

        if (six.totalPrice > maxPrice) maxPrice = six.totalPrice;
      }
      else if (revenue[i].approvalDate.split('T')[0].split('-')[1] === '07') {
        seven.totalPrice += revenue[i].totalPrice;
        seven.cashPrice += revenue[i].cashPrice;
        seven.cardPrice += revenue[i].cardPrice;
        seven.notReceived += revenue[i].notReceivedPrice;

        let selectedPaymentOptions = seven.selectedPaymentOptions.slice();

        for (let j = 0; j < revenue[i].selectedPaymentOptions.length; j++) {
          let isExist = false;

          for (let h = 0; h < selectedPaymentOptions.length; h++) {
            if (revenue[i].selectedPaymentOptions[j].paymentOptionId === selectedPaymentOptions[h].paymentOptionId) {
              selectedPaymentOptions[h].price += revenue[i].selectedPaymentOptions[j].price;
              isExist = true;
              break;
            }
          }

          if (!isExist && revenue[i].selectedPaymentOptions[j].paymentOptionId !== 0) {
            selectedPaymentOptions.push({
              paymentOptionId: revenue[i].selectedPaymentOptions[j].paymentOptionId,
              paymentOptionName: revenue[i].selectedPaymentOptions[j].paymentOptionName,
              price: revenue[i].selectedPaymentOptions[j].price,
            });
          }
        }

        selectedPaymentOptions.sort((a, b) => a.paymentOptionId - b.paymentOptionId);

        seven.selectedPaymentOptions = selectedPaymentOptions;
        seven.sales.push(revenue[i]);

        if (seven.totalPrice > maxPrice) maxPrice = seven.totalPrice;
      }
      else if (revenue[i].approvalDate.split('T')[0].split('-')[1] === '08') {
        eight.totalPrice += revenue[i].totalPrice;
        eight.cashPrice += revenue[i].cashPrice;
        eight.cardPrice += revenue[i].cardPrice;
        eight.notReceived += revenue[i].notReceivedPrice;

        let selectedPaymentOptions = eight.selectedPaymentOptions.slice();

        for (let j = 0; j < revenue[i].selectedPaymentOptions.length; j++) {
          let isExist = false;

          for (let h = 0; h < selectedPaymentOptions.length; h++) {
            if (revenue[i].selectedPaymentOptions[j].paymentOptionId === selectedPaymentOptions[h].paymentOptionId) {
              selectedPaymentOptions[h].price += revenue[i].selectedPaymentOptions[j].price;
              isExist = true;
              break;
            }
          }

          if (!isExist && revenue[i].selectedPaymentOptions[j].paymentOptionId !== 0) {
            selectedPaymentOptions.push({
              paymentOptionId: revenue[i].selectedPaymentOptions[j].paymentOptionId,
              paymentOptionName: revenue[i].selectedPaymentOptions[j].paymentOptionName,
              price: revenue[i].selectedPaymentOptions[j].price,
            });
          }
        }

        selectedPaymentOptions.sort((a, b) => a.paymentOptionId - b.paymentOptionId);

        eight.selectedPaymentOptions = selectedPaymentOptions;
        eight.sales.push(revenue[i]);

        if (eight.totalPrice > maxPrice) maxPrice = eight.totalPrice;
      }
      else if (revenue[i].approvalDate.split('T')[0].split('-')[1] === '09') {
        nine.totalPrice += revenue[i].totalPrice;
        nine.cashPrice += revenue[i].cashPrice;
        nine.cardPrice += revenue[i].cardPrice;
        nine.notReceived += revenue[i].notReceivedPrice;

        let selectedPaymentOptions = nine.selectedPaymentOptions.slice();

        for (let j = 0; j < revenue[i].selectedPaymentOptions.length; j++) {
          let isExist = false;

          for (let h = 0; h < selectedPaymentOptions.length; h++) {
            if (revenue[i].selectedPaymentOptions[j].paymentOptionId === selectedPaymentOptions[h].paymentOptionId) {
              selectedPaymentOptions[h].price += revenue[i].selectedPaymentOptions[j].price;
              isExist = true;
              break;
            }
          }

          if (!isExist && revenue[i].selectedPaymentOptions[j].paymentOptionId !== 0) {
            selectedPaymentOptions.push({
              paymentOptionId: revenue[i].selectedPaymentOptions[j].paymentOptionId,
              paymentOptionName: revenue[i].selectedPaymentOptions[j].paymentOptionName,
              price: revenue[i].selectedPaymentOptions[j].price,
            });
          }
        }

        selectedPaymentOptions.sort((a, b) => a.paymentOptionId - b.paymentOptionId);

        nine.selectedPaymentOptions = selectedPaymentOptions;
        nine.sales.push(revenue[i]);

        if (nine.totalPrice > maxPrice) maxPrice = nine.totalPrice;
      }
      else if (revenue[i].approvalDate.split('T')[0].split('-')[1] === '10') {
        ten.totalPrice += revenue[i].totalPrice;
        ten.cashPrice += revenue[i].cashPrice;
        ten.cardPrice += revenue[i].cardPrice;
        ten.notReceived += revenue[i].notReceivedPrice;

        let selectedPaymentOptions = ten.selectedPaymentOptions.slice();

        for (let j = 0; j < revenue[i].selectedPaymentOptions.length; j++) {
          let isExist = false;

          for (let h = 0; h < selectedPaymentOptions.length; h++) {
            if (revenue[i].selectedPaymentOptions[j].paymentOptionId === selectedPaymentOptions[h].paymentOptionId) {
              selectedPaymentOptions[h].price += revenue[i].selectedPaymentOptions[j].price;
              isExist = true;
              break;
            }
          }

          if (!isExist && revenue[i].selectedPaymentOptions[j].paymentOptionId !== 0) {
            selectedPaymentOptions.push({
              paymentOptionId: revenue[i].selectedPaymentOptions[j].paymentOptionId,
              paymentOptionName: revenue[i].selectedPaymentOptions[j].paymentOptionName,
              price: revenue[i].selectedPaymentOptions[j].price,
            });
          }
        }

        selectedPaymentOptions.sort((a, b) => a.paymentOptionId - b.paymentOptionId);

        ten.selectedPaymentOptions = selectedPaymentOptions;
        ten.sales.push(revenue[i]);

        if (ten.totalPrice > maxPrice) maxPrice = ten.totalPrice;
      }
      else if (revenue[i].approvalDate.split('T')[0].split('-')[1] === '11') {
        eleven.totalPrice += revenue[i].totalPrice;
        eleven.cashPrice += revenue[i].cashPrice;
        eleven.cardPrice += revenue[i].cardPrice;
        eleven.notReceived += revenue[i].notReceivedPrice;

        let selectedPaymentOptions = eleven.selectedPaymentOptions.slice();

        for (let j = 0; j < revenue[i].selectedPaymentOptions.length; j++) {
          let isExist = false;

          for (let h = 0; h < selectedPaymentOptions.length; h++) {
            if (revenue[i].selectedPaymentOptions[j].paymentOptionId === selectedPaymentOptions[h].paymentOptionId) {
              selectedPaymentOptions[h].price += revenue[i].selectedPaymentOptions[j].price;
              isExist = true;
              break;
            }
          }

          if (!isExist && revenue[i].selectedPaymentOptions[j].paymentOptionId !== 0) {
            selectedPaymentOptions.push({
              paymentOptionId: revenue[i].selectedPaymentOptions[j].paymentOptionId,
              paymentOptionName: revenue[i].selectedPaymentOptions[j].paymentOptionName,
              price: revenue[i].selectedPaymentOptions[j].price,
            });
          }
        }

        selectedPaymentOptions.sort((a, b) => a.paymentOptionId - b.paymentOptionId);

        eleven.selectedPaymentOptions = selectedPaymentOptions;
        eleven.sales.push(revenue[i]);

        if (eleven.totalPrice > maxPrice) maxPrice = eleven.totalPrice;
      }
      else if (revenue[i].approvalDate.split('T')[0].split('-')[1] === '12') {
        twelve.totalPrice += revenue[i].totalPrice;
        twelve.cashPrice += revenue[i].cashPrice;
        twelve.cardPrice += revenue[i].cardPrice;
        twelve.notReceived += revenue[i].notReceivedPrice;

        let selectedPaymentOptions = twelve.selectedPaymentOptions.slice();

        for (let j = 0; j < revenue[i].selectedPaymentOptions.length; j++) {
          let isExist = false;

          for (let h = 0; h < selectedPaymentOptions.length; h++) {
            if (revenue[i].selectedPaymentOptions[j].paymentOptionId === selectedPaymentOptions[h].paymentOptionId) {
              selectedPaymentOptions[h].price += revenue[i].selectedPaymentOptions[j].price;
              isExist = true;
              break;
            }
          }

          if (!isExist && revenue[i].selectedPaymentOptions[j].paymentOptionId !== 0) {
            selectedPaymentOptions.push({
              paymentOptionId: revenue[i].selectedPaymentOptions[j].paymentOptionId,
              paymentOptionName: revenue[i].selectedPaymentOptions[j].paymentOptionName,
              price: revenue[i].selectedPaymentOptions[j].price,
            });
          }
        }

        selectedPaymentOptions.sort((a, b) => a.paymentOptionId - b.paymentOptionId);

        twelve.selectedPaymentOptions = selectedPaymentOptions;
        twelve.sales.push(revenue[i]);

        if (twelve.totalPrice > maxPrice) maxPrice = twelve.totalPrice;
      }
    }

    for (let i = 0; i < prevRevenue.length; i++) {
      if (prevRevenue[i].approvalDate.split('T')[0].split('-')[1] === '01') prevOne += prevRevenue[i].totalPrice;
      else if (prevRevenue[i].approvalDate.split('T')[0].split('-')[1] === '02') prevTwo += prevRevenue[i].totalPrice;
      else if (prevRevenue[i].approvalDate.split('T')[0].split('-')[1] === '03') prevThree += prevRevenue[i].totalPrice;
      else if (prevRevenue[i].approvalDate.split('T')[0].split('-')[1] === '04') prevFour += prevRevenue[i].totalPrice;
      else if (prevRevenue[i].approvalDate.split('T')[0].split('-')[1] === '05') prevFive += prevRevenue[i].totalPrice;
      else if (prevRevenue[i].approvalDate.split('T')[0].split('-')[1] === '06') prevSix += prevRevenue[i].totalPrice;
      else if (prevRevenue[i].approvalDate.split('T')[0].split('-')[1] === '07') prevSeven += prevRevenue[i].totalPrice;
      else if (prevRevenue[i].approvalDate.split('T')[0].split('-')[1] === '08') prevEight += prevRevenue[i].totalPrice;
      else if (prevRevenue[i].approvalDate.split('T')[0].split('-')[1] === '09') prevNine += prevRevenue[i].totalPrice;
      else if (prevRevenue[i].approvalDate.split('T')[0].split('-')[1] === '10') prevTen += prevRevenue[i].totalPrice;
      else if (prevRevenue[i].approvalDate.split('T')[0].split('-')[1] === '11') prevEleven += prevRevenue[i].totalPrice;
      else if (prevRevenue[i].approvalDate.split('T')[0].split('-')[1] === '12') prevTwelve += prevRevenue[i].totalPrice;
    }

    let newData = [];

    one.prevTotalPrice = prevOne;
    two.prevTotalPrice = prevTwo;
    three.prevTotalPrice = prevThree;
    four.prevTotalPrice = prevFour;
    five.prevTotalPrice = prevFive;
    six.prevTotalPrice = prevSix;
    seven.prevTotalPrice = prevSeven;
    eight.prevTotalPrice = prevEight;
    nine.prevTotalPrice = prevNine;
    ten.prevTotalPrice = prevTen;
    eleven.prevTotalPrice = prevEleven;
    twelve.prevTotalPrice = prevTwelve;

    newData.push(one);
    newData.push(two);
    newData.push(three);
    newData.push(four);
    newData.push(five);
    newData.push(six);
    newData.push(seven);
    newData.push(eight);
    newData.push(nine);
    newData.push(ten);
    newData.push(eleven);
    newData.push(twelve);

    let totalPrice = 0;
    let totalSales = [];

    if (today.format('YYYY-MM-DDTHH:mm:ss').split('T')[0].split('-')[1] === '01') {
      totalPrice = one.totalPrice;
      totalSales = one.sales;
    }
    else if (today.format('YYYY-MM-DDTHH:mm:ss').split('T')[0].split('-')[1] === '02') {
      totalPrice = two.totalPrice;
      totalSales = two.sales;
    }
    else if (today.format('YYYY-MM-DDTHH:mm:ss').split('T')[0].split('-')[1] === '03') {
      totalPrice = three.totalPrice;
      totalSales = three.sales;
    }
    else if (today.format('YYYY-MM-DDTHH:mm:ss').split('T')[0].split('-')[1] === '04') {
      totalPrice = four.totalPrice;
      totalSales = four.sales;
    }
    else if (today.format('YYYY-MM-DDTHH:mm:ss').split('T')[0].split('-')[1] === '05') {
      totalPrice = five.totalPrice;
      totalSales = five.sales;
    }
    else if (today.format('YYYY-MM-DDTHH:mm:ss').split('T')[0].split('-')[1] === '06') {
      totalPrice = six.totalPrice;
      totalSales = six.sales;
    }
    else if (today.format('YYYY-MM-DDTHH:mm:ss').split('T')[0].split('-')[1] === '07') {
      totalPrice = seven.totalPrice;
      totalSales = seven.sales;
    }
    else if (today.format('YYYY-MM-DDTHH:mm:ss').split('T')[0].split('-')[1] === '08') {
      totalPrice = eight.totalPrice;
      totalSales = eight.sales;
    }
    else if (today.format('YYYY-MM-DDTHH:mm:ss').split('T')[0].split('-')[1] === '09') {
      totalPrice = nine.totalPrice;
      totalSales = nine.sales;
    }
    else if (today.format('YYYY-MM-DDTHH:mm:ss').split('T')[0].split('-')[1] === '10') {
      totalPrice = ten.totalPrice;
      totalSales = ten.sales;
    }
    else if (today.format('YYYY-MM-DDTHH:mm:ss').split('T')[0].split('-')[1] === '11') {
      totalPrice = eleven.totalPrice;
      totalSales = eleven.sales;
    }
    else if (today.format('YYYY-MM-DDTHH:mm:ss').split('T')[0].split('-')[1] === '12') {
      totalPrice = twelve.totalPrice;
      totalSales = twelve.sales;
    }

    setThisYear(newData);
    setThisYearMaxPrice(maxPrice);
    setMaximum((parseInt(maxPrice) + parseInt(maxPrice * 0.1)));
  }, [revenue, prevRevenue, today])

  // 회원권 별 매출 비율 계산 //
  useEffect(() => {
    let finalMembershipSales = [];
    let membershipSales = memberships.slice();
    let totalPrice = 0;

    for (let i = 0; i < membershipSales.length; i++) {
      let membershipPrice = 0;

      for (let j = 0; j < revenue.length; j++) {
        let approvalDate = moment(revenue[j].approvalDate);
        if (approvalDate.isBetween(startDate, endDate, undefined, '[]')) {
          if (membershipSales[i].membershipId === revenue[j].membershipId) {
            membershipPrice += (revenue[j].totalPrice);
          }
        }
      }

      totalPrice += membershipPrice;
      membershipSales[i].membershipSaleAmount = membershipPrice;
    }

    for (let i = 0; i < membershipSales.length; i++) {
      if (membershipSales[i].membershipSaleAmount === 0) membershipSales[i].saleRatio = 0;
      else membershipSales[i].saleRatio = ((membershipSales[i].membershipSaleAmount / totalPrice) * 100).toFixed(2);
    }

    for (let i = 0; i < membershipSales.length; i++) {
      if (membershipSales[i].saleRatio !== '0.00') finalMembershipSales.push(membershipSales[i]);
    } 

    finalMembershipSales.sort((a, b) => parseFloat(b.saleRatio) - parseFloat(a.saleRatio));
    
    setThisMonthTotalPrice(totalPrice);
    setMembershipSaleRateInfos(finalMembershipSales);

    setTimeout(() => (
      setIsRevenueLoading(false)
    ), 3000)
  }, [revenue, memberships, startDate, endDate])


  return (
    <TopLevelWrapper>
      <InfoBox>
        <TitleWrapper>
          <Title>{calcDateText() + ' 회원권별 판매 현황'}</Title>
          <TotalPriceWrapper>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#000000' hover='default'>총 매출 : </Text>
            <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#000000' hover='default'>{thisMonthTotalPrice.toLocaleString('ko-KR') + '원'}</Text>
          </TotalPriceWrapper>
        </TitleWrapper>
        {
          isRevenueLoading ?
            <AnimationBox>
              <LottieWrapper>
                <Lottie animationData={LoadingAnimation} loop={true} />
              </LottieWrapper>
            </AnimationBox>
            :
            <InnerInfoBox>
              {
                isOpenPartnerGymSales ?
                  <InfoView>
                    <MemberBox>
                      <MemberColumn>
                        <Text style={{ marginLeft: '26px', marginRight: `142px` }} fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' hover='default'>회원권</Text>
                        <Text style={{ marginRight: `28px` }} fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' hover='default'>회원권 가격</Text>
                        <Text style={{ marginRight: `24px` }} fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' hover='default'>총 판매 금액</Text>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' hover='default'>비중</Text>
                      </MemberColumn>
                      <MemberListView>
                        {
                          membershipSaleRateInfos.map((data, index) => (
                            <EngagementMemberWrapper key={'MembershipSaleRatio-' + index}>
                              <EngagementTextBox width={18}>
                                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' hover='pointer'>{index + 1}</Text>
                              </EngagementTextBox>
                              <EngagementTextBox width={180}>
                                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' hover='pointer'>{data.membershipName}</Text>
                              </EngagementTextBox>
                              <EngagementTextBox width={90}>
                                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' hover='pointer'>{data.price.toLocaleString('ko-KR') + '원'}</Text>
                              </EngagementTextBox>
                              <EngagementTextBox width={90}>
                                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' hover='pointer'>{data.membershipSaleAmount.toLocaleString('ko-KR') + '원'}</Text>
                              </EngagementTextBox>
                              <EngagementTextBox width={58}>
                                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' hover='pointer'>{data.saleRatio + '%'}</Text>
                              </EngagementTextBox>
                            </EngagementMemberWrapper>
                          ))
                        }
                      </MemberListView>
                    </MemberBox>
                  </InfoView>
                  :
                  <NotOpenTextWrapper>
                    <Text fontFamily='NotoSansKR-Bold' fontSize={15} color='#444444' cursor='default'>이 업체는 파트너 체육관에 매출을 비공개 합니다</Text>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={15} color='#444444' cursor='default'>링크존 설정에서 “파트너 체육관”에서 권한 설정해 주세요</Text>
                  </NotOpenTextWrapper>
              }
            </InnerInfoBox>
        }
      </InfoBox>

      <BoxDivisionLine />

      <InfoBox>
        <Title>{today.clone().format('YYYY년')} 월 별 매출 비교</Title>
        {
          isMonthAttendanceLoading ?
            <AnimationBox>
              <LottieWrapper>
                <Lottie animationData={LoadingAnimation} loop={true} />
              </LottieWrapper>
            </AnimationBox>
            :
            <InnerInfoBox>
              {
                isOpenPartnerGymSales ?
                  <InfoView>
                    <TotalChartWrapper>
                      <ChartWrapper>
                        <MonthlyDateWrapper>
                          {
                            monthlyDate.map((data, index) => (
                              <MonthlyDateText key={'MonthlyDateText-' + index}>{data}</MonthlyDateText>
                            ))
                          }
                        </MonthlyDateWrapper>
                        <ChartView>
                          {
                            thisYear.map((data, index) => (
                              <NewDataBar
                                key={'DateBar-' + index}
                                today={today}
                                data={data}
                                index={index}
                                thisYear={thisYear}
                                maximum={maximum}
                                thisYearMaxPrice={thisYearMaxPrice}
                                totalMaxPrice={totalMaxPrice}
                                // totalMaxPrice={3200000} 
                              />
                            ))
                          }
                        </ChartView>
                      </ChartWrapper>
                    </TotalChartWrapper>
                  </InfoView>
                  :
                  <NotOpenTextWrapper>
                    <Text fontFamily='NotoSansKR-Bold' fontSize={15} color='#444444' cursor='default'>이 업체는 파트너 체육관에 매출을 비공개 합니다</Text>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={15} color='#444444' cursor='default'>링크존 설정에서 “파트너 체육관”에서 권한 설정해 주세요</Text>
                  </NotOpenTextWrapper>
              }
            </InnerInfoBox>
        }
      </InfoBox>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 1020px;
  height: 448px;

  gap: 28px;
  margin-top: 38px;

  border-radius: 30px;
  box-shadow: 0 40px 50px rgba(240, 232, 227, 0.5);
  background-color: #FFFFFF;
`;

const BoxDivisionLine = styled.div`
  display: flex;
  flex-direction: row;

  width: 1px;
  height: 392px;

  background-color: #ECECEC;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 44.5%;
`;

const InnerInfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 364px;
`;

const InfoView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const Title = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #232323;

  margin: 0 0 0 0;
`;

const TotalPriceWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const AnimationBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  z-index: 5;

  width: 100%;
  height: 364px;

  background-color: #FFFFFF;
`;

const LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 80px;
  height: 80px;
`;

const MemberBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding-top: 14px;
  margin-top: 38px;

  width: 470px;
  height: 318px;

  border-top: 1px solid #DFDFDF;
`;

const MemberColumn = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0px 8px 0px 8px;

  width: calc(100% - 16px);
  height: 32px;

  border-radius: 8px 8px 0px 0px;
  background-color: #ECECEC;
`;

const MemberListView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  height: 288px;

  overflow-y: scroll;
  overflow-x: none;

  &::-webkit-scrollbar {
    width: 2px;
  }

  &::-webkit-scrollbar-thumb {
		border: 3px solid transparent;
		background-color: #DADADA;
		border-radius: 200px;
	}

  &::-webkit-scrollbar-track {
		background-color: #FFFFFF;
		border-radius: 200px;
	}
`;

const EngagementMemberWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0px 8px 0px 8px;

  gap: 8px;

  width: calc(100% - 16px);
  min-height: 36px;
  max-height: 36px;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;

    border-radius: 5px;
    background-color: #ECECEC;
  }
`;

const EngagementTextBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: ${props => props.width}px;
  height: 20px;

  overflow: hidden;
`;

const TopUIWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 24px;
`;

const WeekAttendanceIcon = styled.img`
  width: 48px;
  height: 48px;

  margin-right: 8px;
`;

const WeekAttendancePersent = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 133px;
  height: 28px;

  border-radius: 8px;
  background-color: #6DD2A6;
`;

const MonthAverageAttendancePersent = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 133px;
  height: 28px;

  border-radius: 8px;
  background-color: #FFA800;
`;

const PersentText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #FFFFFF;

  margin: 0 3px 0 0;
`;

const PersentNumber = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: #FFFFFF;

  margin: 0 0 0 0;
`;

const DivisionLine = styled.div`
  display: flex;
  flex-direction: row;

  width: ${props => props.width}px;
  height: 1px;

  margin: 0 16px 0 16px;
  border: 1px solid #ECECEC;
`;

const ResultBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: ${props => props.width}px;
  height: 28px;

  border-radius: 8px;
  background-color: #ECECEC;
`;

const ResultText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #777777;

  margin: 0 0 0 0;
`;

const ResultNumber = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: #777777;

  margin: 0 0 0 0;
`;

const ListTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  margin-top: 24px;

  width: 100%;
`;

const ListTitle = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #595959;

  margin: 0 0 0 0;
`;

const WeeklySelectWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const WeeklySelectButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 16px;
  height: 16px;

  border: 1px solid #DFDFDF;
  border-radius: 17px;
  background-color: #FFFFFF;

  &:hover {
    cursor: pointer;
  }
`;

const WeeklySelectButtonImage = styled.img`
  width: 10px;
  height: 10px;

  object-fit: contain;

  &:hover {
    cursor: pointer;
  }
`;


const PriceTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
  
  gap: 4px;
`;

const NotOpenTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const TotalChartWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-end;
  align-items: center;

  margin-top: 24px;

  width: 453px;
  height: 318px;

  border-top: 1px solid #DFDFDF;
`;

const ChartWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 304px;
`;

const MonthlyDateWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  gap: 5.4px;
`;

const MonthlyDateText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #777777;

  margin: 0 0 0 0;
`;

const ChartView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 416px;
  height: 304px;

  border-left: 1px solid #CBCBCB;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;